import { getLang as documentUtilsGetLang } from '@utils/documentUtils';
import { dateConstants } from '@utils/constants';
import { dateUtils } from '@utils';

export default function dateTimeLongFormat(value, language = documentUtilsGetLang()) {
    return dateUtils.format(value, dateConstants.FORMAT.DATE_TIME_LONG, language);
}
